import {EntityStateAdapter} from '@/store/base.store';
import {InvitationMode, InvitationsModel, InvitationStatus} from '@/models/team.model';
import {Action, Module} from 'vuex-module-decorators';
import store from '@/store';
import {UserTeamsApi} from '@/api/user-teams.api';
import {PaginatedParams} from '@/api/base.api';
import {take} from 'rxjs/operators';

export const featureKey = 'user_teams_invitations';

// @ts-ignore
if (store.state.user_teams_invitations) {
  store.unregisterModule(featureKey)
}

@Module({
  store,
  dynamic: true,
  name: featureKey,
  namespaced: true,
})
export class UserTeamsInvitationsStoreModule extends EntityStateAdapter<InvitationsModel> {

  get loading(): boolean {
    return super.loading;
  }

  get lastPage(): number {
    return super.lastPage;
  }

  get currentPage(): number {
    return super.currentPage;
  }

  get entities(): InvitationsModel[] {
    return super.entities;
  }

  get invitesByStatus(): (status: InvitationStatus) => InvitationsModel[] {
    return (status: InvitationStatus) => this._entities.filter((v) => v.status === status)
  }

  get invitesByMode(): (mode: InvitationMode) => InvitationsModel[] {
    return (mode: InvitationMode) => this._entities.filter((v) => v.invitation_mode === mode)

  }

  get invitesByModeAndStatus(): (mode: InvitationMode, status: InvitationStatus) => InvitationsModel[] {
    return (mode: InvitationMode, status: InvitationStatus) => {
      return this._entities.filter((v) => v.invitation_mode === mode && v.status === status)
    }
  }

  @Action({commit: 'upsertMany', rawError: true})
  async fetchAllInvitations(data: {
    params: PaginatedParams,
    status?: InvitationStatus,
    mode?: InvitationMode
  }): Promise<InvitationsModel[]> {
    this.updateLoading(true);

    const response = await new UserTeamsApi().allInvitations(data.params, data.mode, data.status)
      .pipe(take(1))
      .toPromise();

    this.updatePageParams(response);
    return response.data;
  }

  @Action({commit: 'upsertOne', rawError: true})
  async acceptInvite(data: {
    challengeId: number,
    teamId: number,
    inviteId: number
  }): Promise<InvitationsModel> {
    this.updateLoading(true);
    return new UserTeamsApi().acceptInvitation(data.challengeId, data.teamId, data.inviteId).toPromise()
  }

  @Action({commit: 'upsertOne', rawError: true})
  async rejectInvite(data: {
    challengeId: number,
    teamId: number,
    inviteId: number
  }): Promise<InvitationsModel> {
    this.updateLoading(true);
    return new UserTeamsApi().refuseInvitation(data.challengeId, data.teamId, data.inviteId).toPromise()
  }
}
